
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"18","height":"19","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('rect',{attrs:{"x":".5","y":".5","width":"17","height":"10.667","rx":"1.5","fill":"#fff","stroke":"#585858"}}),_c('g',{attrs:{"filter":"url(#filter0_d_16763_14496)"}},[_c('path',{attrs:{"stroke":"#585858","d":"M4.91 13.5h8.182"}})]),_c('defs',[_c('filter',{attrs:{"id":"filter0_d_16763_14496","x":".91","y":"10","width":"16.184","height":"9","filterUnits":"userSpaceOnUse","color-interpolation-filters":"sRGB"}},[_c('feFlood',{attrs:{"flood-opacity":"0","result":"BackgroundImageFix"}}),_c('feColorMatrix',{attrs:{"in":"SourceAlpha","values":"0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0","result":"hardAlpha"}}),_c('feOffset',{attrs:{"dy":"1"}}),_c('feGaussianBlur',{attrs:{"stdDeviation":"2"}}),_c('feColorMatrix',{attrs:{"values":"0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"}}),_c('feBlend',{attrs:{"in2":"BackgroundImageFix","result":"effect1_dropShadow_16763_14496"}}),_c('feBlend',{attrs:{"in":"SourceGraphic","in2":"effect1_dropShadow_16763_14496","result":"shape"}})])])])
          )
        }
      }
    